import { COLORS } from '../../constants';
export const getBorderColor = (serie)=>{
    if ([
        'averageHigh',
        'averageLow',
        'averageTarget'
    ].includes(serie.serieId)) {
        return 'average';
    }
    return 'transparent';
};
export const getPlainValuesColor = (calculationFormula)=>{
    if (calculationFormula === 'HYPERGLYCEMIA') {
        return '#F4C32C';
    }
    if (calculationFormula === 'HYPOGLYCEMIA') {
        return '#F74053';
    }
    return COLORS.plain;
};
export const getIsPlainValuesMode = (calculationFormula)=>[
        'COUNT',
        'HYPERGLYCEMIA',
        'HYPOGLYCEMIA'
    ].includes(calculationFormula);
export const getMaxPlainValue = (calculationFormula)=>{
    if ([
        'HYPERGLYCEMIA',
        'HYPOGLYCEMIA'
    ].includes(calculationFormula)) {
        return 100;
    }
    return 20;
};
export const getUnitSymbol = (calculationFormula)=>{
    if ([
        'HYPERGLYCEMIA',
        'HYPOGLYCEMIA'
    ].includes(calculationFormula)) {
        return '%';
    }
    return null;
};
export const getClickToPointDistance = (point, evt)=>{
    const bounds = evt.currentTarget.getBoundingClientRect();
    const x = evt.clientX - bounds.left;
    const y = evt.clientY - bounds.top;
    const distanceX = point.x - x;
    const distanceY = point.y - y;
    return Math.sqrt(distanceX * distanceX + distanceY * distanceY);
};
export const getRoundedTimestamp = (timestamp)=>Math.round(timestamp / 300) * 300;
export const getTimestampFromX = (x, xScale)=>{
    const timestamp = Math.round(xScale.invert(x + 15));
    return getRoundedTimestamp(timestamp);
};
